export default {
    newHome: {
        eyebrow: 'Online and personalized Will writing',
        heroTitle: 'Create your Will for {{location}} and assets worldwide',
        heroBody:
            'Create your Will online or work one-to-one with an estate planning specialist. NobleWills supports individuals, couples and families in {{location}} and abroad, including those with assets across multiple countries.',
        primaryCta: 'Find the right Will service',
        heroPrimaryCta: 'Compare Will services',
        secondaryCta: 'See how it works',
        talkToExpert: 'Talk to an expert',
        trustHuman: 'Reviewed by real people',
        trustSecure: 'Encrypted and private',
        trustCrossBorder: 'Cross-border support',
        chooserEyebrow: 'Two ways to make your Will',
        chooserTitle: 'Choose how you want to make your Will',
        chooserBody: 'Both services provide clear guidance and human support. Choose the experience that best fits your circumstances and how you prefer to work.',
        onlineLabel: 'Self-paced with human review',
        onlineTitle: 'Online Will Writing Service',
        onlineBody: 'Best for relatively straightforward wishes when you are comfortable answering guided questions online at your own pace.',
        onlineBenefit1: 'Complete guided questions at your own pace',
        onlineBenefit2: 'Human review before your documents are finalized',
        onlineBenefit3: 'Save your progress and get support when needed',
        onlineCta: 'Explore Online Wills',
        premiumLabel: 'One-to-one personal guidance',
        premiumTitle: 'Premium Will Writing Service',
        premiumBody: 'Best for complex, sensitive, or international circumstances—or when you would simply prefer to plan your Will personally with our team.',
        premiumBenefit1: 'Private estate planning session',
        premiumBenefit2: 'Personalized planning and customized drafting',
        premiumBenefit3: 'One-to-one guidance through finalization',
        premiumCta: 'Explore Premium Wills',
        individualPriceLabel: 'Individual Will',
        couplePriceLabel: 'Couple Wills',
        coupleSavings: 'Save {{savings}}',
        onlinePricingNote: 'Prices are shown per jurisdiction.',
        premiumPricingNote: 'Prices are shown for your first Will. Additional countries are priced separately.',
        questionnairePrompt: 'Not sure which Will service is right for you?',
        questionnaireCta: 'Answer a few questions',
        stakesEyebrow: 'Why making a Will matters',
        stakesTitle: 'Important decisions should not be left unclear.',
        stakesBody:
            'A Will records who should manage your estate, who should receive your assets, and who you would like to care for your children. NobleWills helps you work through those choices clearly, without legal jargon or unnecessary pressure.',
        guideEyebrow: 'Trusted guidance, thoughtfully delivered',
        guideTitle: 'Estate planning expertise, supported by secure technology',
        guideCredentialTitle: 'Built by legal and technology specialists',
        guideCredentialBody: 'Founded by a qualified lawyer and software engineer, combining estate-planning experience with practical product engineering.',
        guideReviewTitle: 'Human guidance and review',
        guideReviewBody: 'Every Online Will receives a human consistency check. Premium clients receive one-to-one support through planning, drafting, and finalization.',
        guideSecurityTitle: 'Private and encrypted',
        guideSecurityBody: 'Your personal information is protected through encryption in transit, at the field level, and at rest.',
        guidePartnersTitle: 'Strategic partners',
        reviewStats: '{{rating}}/5 from {{count}} Google reviews',
        reviewFallback: 'Read our Google customer reviews',
        reviewStarsLabel: '5 out of 5 stars',
        guideLegalFounderAlt: 'NobleWills qualified lawyer and co-founder',
        guideLegalFounderName: 'Sarah Ip',
        guideLegalFounderRole: 'Qualified lawyer (HK)',
        guideLegalFounderTitle: 'CEO and Co-Founder',
        guideTechFounderAlt: 'NobleWills software engineer and co-founder',
        guideTechFounderName: 'Brian MacPherson',
        guideTechFounderRole: 'Software engineer',
        guideTechFounderTitle: 'CTO and Co-Founder',
        processEyebrow: 'A straightforward process',
        processTitle: 'Your Will in three clear steps',
        step1Title: 'Find the right service',
        step1Body: 'Explore our Online and Premium services, then choose the option that best suits how you prefer to plan your Will.',
        step2Title: 'Tell us what matters',
        step2Body: 'Share details about your family, assets, wishes, and the countries involved.',
        step3Title: 'Review and complete your Will',
        step3Body: 'Receive your documents, review them carefully, and follow our signing instructions.',
        processOutcome: 'You’ll always know what to do next, with guidance available along the way.',
        successEyebrow: 'Clarity for what comes next',
        successTitle: 'An estate plan your family can understand',
        successBody: 'Record your wishes, organize the people responsible for carrying them out, and put clear instructions in place for the people you care about.',
        success1: 'Appoint executors and guardians',
        success2: 'Provide for partners, family, pets, and charities',
        success3: 'Record gifts and organize your assets',
        success4: 'Plan for assets held across countries',
        crossBorderEyebrow: 'Wills across borders',
        crossBorderTitle: 'Wills for assets across multiple jurisdictions',
        crossBorderBody: 'Explore where NobleWills can help through our online and premium will services.',
        crossBorderCta: 'Ask about cross-border Wills',
        jurisdictionMapLabel: 'World map of jurisdictions supported by NobleWills',
        jurisdictionOnlineLegend: 'Online & Premium',
        jurisdictionPremiumLegend: 'Premium Only',
        jurisdictionOnlineDescription: 'Available through the Online and Premium Will Service',
        jurisdictionPremiumDescription: 'Available through the Premium Service only',
        jurisdictionOnlineCta: 'View Online service countries',
        jurisdictionPremiumCta: 'View Premium service countries',
        relatedEyebrow: 'More ways to plan ahead',
        relatedTitle: 'Related estate planning services',
        relatedBody: 'A Will is often the starting point. Explore additional services available in your location when you need them.',
        relatedPowerTitle: 'Enduring Powers of Attorney',
        relatedPowerBody: 'Appoint someone you trust to manage financial matters if you lose mental capacity.',
        relatedGuardianshipTitle: 'Temporary guardianship',
        relatedGuardianshipBody: 'Record who should care for your children during an urgent or temporary situation.',
        relatedSessionTitle: 'Estate planning sessions',
        relatedSessionBody: 'Discuss executors, guardians, overseas assets, and practical next steps with a Will specialist.',
        relatedStorageTitle: 'Secure Will storage',
        relatedStorageBody: 'Store original documents securely and make retrieval clearer for you and your executors.',
        relatedCta: 'Learn more',
        faqEyebrow: 'Will writing questions',
        faqTitle: 'What people usually want to know',
        faq1Question: 'Should I choose the Online or Premium Will service?',
        faq1Answer:
            'The Online service works well for relatively straightforward wishes and people comfortable completing guided questions at their own pace. Premium is better suited to complex or sensitive circumstances, or anyone who prefers a private consultation and more personalized guidance.',
        faq2Question: 'Can I make a Will online?',
        faq2Answer:
            'Yes. Our guided Online Will service lets you answer questions, save your progress, and receive human support and consistency checks before your documents are finalized.',
        faq3Question: 'Can NobleWills help with assets in multiple countries?',
        faq3Answer:
            'NobleWills supports estate planning across multiple jurisdictions. Selected jurisdictions are available directly through the platform, and our team can help arrange others outside it. Each jurisdiction is handled and priced separately.',
        faq4Question: 'Will a specialist check my Will?',
        faq4Answer:
            'Yes. We conduct a consistency check on Online Will submissions, while Premium clients work personally with an estate planning specialist through guidance, drafting, and finalization.',
        faq5Question: 'How do signing and witnessing work?',
        faq5AnswerInPersonWitnessing:
            'For Premium Wills, and for Online Wills where Witnessing Service is available and selected, we meet you in person to sign and witness your Wills. Alternatively, your completed documents include signing and witnessing instructions. Requirements depend on the jurisdiction, so follow the instructions supplied with each Will carefully.',
        faq5Answer:
            'Your completed documents include signing and witnessing instructions. Requirements depend on the jurisdiction, so follow the instructions supplied with each Will carefully.',
        faq6Question: 'Can I update my Will later?',
        faq6Answer:
            'Yes. Both the Online and Premium services offer an editing membership for future updates. You can review the membership details and pricing before choosing it.',
        finalEyebrow: 'Start with the service that fits',
        finalTitle: 'Choose the Will writing service that fits your needs.',
        finalBody: 'Make your Will online at your own pace or get more personalized guidance from our Premium team.',
        mobileCta: 'Choose my Will service',
        imageAlt: 'A family reviewing their estate planning documents together at home',
    },
};
